import { useContext } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import { AllModules, ColDef } from "@ag-grid-enterprise/all-modules";
import { useEffect } from "react";
import { DarkThemeContext, SearchContext } from "src/utils/context";

import { useTemplateGridOptions } from "src/hooks/useTemplateGridOptions";
import { relativeTime } from "src/utils/utils";
import "../TemplateGrid.scss";

export default function TemplateRunsGrid() {
    const dark = useContext(DarkThemeContext);
    const [search] = useContext(SearchContext);
    const [gridOptions, gridApi] = useTemplateGridOptions(columnDefs);

    useEffect(() => {
        if (gridApi) {
            gridApi.setQuickFilter(search);
        }
    }, [gridApi, search]);

    return (
        <>
            <div id="template-grid">
                <div className={`ag-theme-balham${dark ? "-dark" : " "} ag`}>
                    <AgGridReact modules={AllModules} gridOptions={gridOptions} />
                </div>
            </div>
        </>
    );
}

const columnDefs: ColDef[] = [
    {
        colId: "templateId",
        headerName: "Id",
        field: "templateId",
        cellClass: "no-border",
        hide: true
    },
    {
        colId: "company",
        headerName: "Company",
        field: "company",
        cellClass: "no-border",
        pinned: "left"
    },
    {
        colId: "name",
        headerName: "Name",
        field: "name",
        cellClass: "no-border"
        // cellRenderer: "companyCellRenderer"
    },
    {
        colId: "status",
        headerName: "Run Status",
        field: "name",
        cellClass: "no-border"
        // cellRenderer: "companyCellRenderer"
    },
    {
        colId: "updateOn",
        headerName: "Last Updated",
        field: "updatedOn",
        valueGetter: ({ data }) => new Date(data.updatedOn),
        valueFormatter: ({ data }) => relativeTime(data.updatedOn),
        //tooltipValueGetter: ({ value }) => localTime(value),
        cellClass: "no-border",
        filter: ""
    }
    // {
    //     colId: "createdOn",
    //     headerName: "Created On",
    //     field: "createdOn",
    //     valueFormatter: ({ data }) => localTime(data.createdOn),
    //     cellClass: "no-border"
    // },
];
